import { IsNotEmpty } from 'class-validator-i18n';

export class AuthenticateByMMWRequestDTO {
  @IsNotEmpty()
  accessToken: string;

  @IsNotEmpty()
  language: string;
}
